module.exports = __webpack_public_path__ + "img/sit_and_stand_banner.f3305079.png";